import {createAction} from 'redux-actions';
import {getSearchedContentItems} from '@pluto/rest';
import {SearchedContentRequest} from '../SearchTypes';

export const SEARCH_ITEMS_SET = 'SEARCH_ITEMS_SET';
export const SEARCH_ITEMS_RESET = 'SEARCH_ITEMS_RESET';

export const setSearchItemsAction = createAction(
    SEARCH_ITEMS_SET,
    async (params: SearchedContentRequest) => {
        return await getSearchedContentItems(params);
    }
);

export const resetSearchItems = createAction(SEARCH_ITEMS_RESET);
